import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/services";
import QuoteForm from "@/components/QuoteForm";

const Services = () => (
  <div data-testid="services-page">
    <section className="bg-crest-green text-white">
      <div className="mx-auto max-w-7xl px-6 py-20 md:py-24">
        <p className="text-xs uppercase tracking-[0.22em] text-crest-gold">Our services</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05]">
          Four specialisms. <br/>One trusted contractor.
        </h1>
        <p className="mt-6 max-w-2xl text-white/80 font-body">
          Each of our services is delivered by experienced trades who specialise in that area — not generalists stretching themselves thin.
        </p>
      </div>
    </section>

    <section className="mx-auto max-w-7xl px-6 py-16 md:py-24 space-y-20">
      {SERVICES.map((s, idx) => (
        <div key={s.slug} id={s.slug} className={`grid lg:grid-cols-12 gap-10 items-center ${idx % 2 ? "lg:[&>div:first-child]:order-2" : ""}`}>
          <div className="lg:col-span-6">
            <img src={s.image} alt={s.name} className="rounded-lg w-full aspect-[4/3] object-cover border border-border" data-testid={`service-image-${s.slug}`} />
          </div>
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.22em] text-crest-gold font-medium">0{idx + 1} · Service</p>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-crest-navy leading-tight">{s.name}</h2>
            <p className="mt-4 text-muted-foreground font-body">{s.short}</p>
            <ul className="mt-6 grid sm:grid-cols-2 gap-2 text-sm">
              {s.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3"><span className="mt-2 h-1.5 w-1.5 rounded-full bg-crest-gold shrink-0" /><span className="text-crest-navy">{b}</span></li>
              ))}
            </ul>
            <Link to={`/services/${s.slug}`} className="mt-7 inline-flex items-center gap-2 rounded-md bg-crest-green px-6 py-3 text-sm font-semibold text-white hover:bg-crest-green-700 transition-colors duration-200" data-testid={`service-detail-link-${s.slug}`}>
              Read more & FAQs <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      ))}
    </section>

    <section id="quote" className="bg-crest-surface border-t border-border">
      <div className="mx-auto max-w-5xl px-6 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.22em] text-crest-gold font-medium">Free estimate</p>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-crest-navy">Let’s scope your project.</h2>
        </div>
        <div className="mt-10">
          <QuoteForm />
        </div>
      </div>
    </section>
  </div>
);

export default Services;
